export class Autocomplete {
    constructor(element, start = 3, list = []) {
        this._element = element;
        this._listener = null;
        this._list = list;
        this._currentFocus;
        this._start = start;

        this._holder = OVS.app.helper.getClosest(this._element, '.form-validate-parent');
        this.init();
    };

    set list(value) {
        this._list = value;
        this.checkSingleValue();
    }

    set listener(value) {
        this._listener = value;
        this.initListener();
    }

    set elementValue(value) {
        this._element.value = value;
        this._element.dispatchEvent(new Event('change'));
        //this._element.dispatchEvent(new Event('blur'));
    }
    
    set listenerValue(value) {
        if (this._listener) {
            this._listener.value = value;
            //this._listener.dispatchEvent(new Event('change'));
            this._listener.dispatchEvent(new Event('blur'));
        }
    }
    
    init() {
        document.addEventListener('click', event => {
            this.closeAllLists(event.target);
        });
    }

    update() {
        this.closeAllLists();
        this._currentFocus = -1;
        
        let bounds = this._holder.getBoundingClientRect();

        let a = document.createElement('DIV');
        a.id = this._element.id + 'autocomplete-list';
        a.classList.add('autocomplete-items');
        a.style.width = bounds.width + 'px';

        this._holder.appendChild(a);

        this._list.forEach(entry => {
            let b = document.createElement("DIV");
            b.innerHTML = entry.name;
            b.innerHTML += ' ('+entry.postalCode+')';
            b.innerHTML += "<input type='hidden' value='" + entry.name + "'>";
            b.innerHTML += "<input type='hidden' value='" + entry.postalCode + "'>";
                
            b.addEventListener('click', event => {
                this.elementValue = event.currentTarget.getElementsByTagName("input")[0].value;
                if (this._listener) {
                    this.listenerValue = event.currentTarget.getElementsByTagName("input")[1].value;
                }
                this.closeAllLists();
            });
            a.appendChild(b);
        });
    }

    initListener() {
        if (this._listener) {
            this._listener.addEventListener('input', () => {
                if (this._listener.value.length >= this._start) {
                    this.getLocalitys(this._listener.value);
                }
            });
        }
    }

    checkSingleValue() {
        if (this._list.length == 1) {
            this.elementValue = this._list[0].name;
        }
    }

    closeAllLists(element) {
        let items = document.getElementsByClassName('autocomplete-items');
        if (items) {
            items.forEach(item => {
                if (element != item && element != this._element) {
                    item.parentNode.removeChild(item);
                }
            });
        }
    }

    getLocalitys(postcode) {
        let request = new Request('GET', '/site/data/locations/' + postcode);
        request.call(data => {
            this.list = data;
            this.update();
        }, () => {
            console.log("error");
        });
    }
}
